import { axios } from '../../services/axios';

export default async function createGCCHService(companyId) {
    return axios
        .post('/Service/DirectRoutingGCCH', {
            name: 'Direct Routing GCC High',
            companyId,
        })
        .then((res) => res)
        .catch((e) => e);
}
